import { render, staticRenderFns } from "./ModalAuditConfig.vue?vue&type=template&id=788fddbc&"
import script from "./ModalAuditConfig.vue?vue&type=script&lang=js&"
export * from "./ModalAuditConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports